import { CanActivateFn } from '@angular/router';
import { roleGuard } from './role.guard';

/**
 * Guard для защиты админ панели
 * Доступ только для пользователей с ролью quota_operator, quota_manager или quota_viewer
 */
export const adminGuard: CanActivateFn = roleGuard(['quota_operator', 'quota_manager', 'quota_viewer'], '/');
